define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseCategoriesWidget = require('web-agent-widgets/BaseCategoriesWidget');
    var VisitInfoBase = require('web-agent-widgets/VisitInfoBase');
    var widgetConfig = require('web-agent-widgets/widgetConfig');

    var ConsumerInfoWidget = VisitInfoBase.extend({
        ControllerName: "ConsumerInfoWidget",
        applicationType: "ConsumerInfoWidget",
        initialize: function (constructorData) {
            this.visitorId = constructorData.visitorId;
        },
        events: function () {
            if (this.singleton) {
                this.viewEventsHandler.bindEvent({appName : this.tableName , UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_CLOSED, callback: this.handleWidgetClose});
            }
            this.unbindModel({modelPath : 'participants.myEngagements.' + this.visitorId + ".chats", callback: this.updateChatId}); //for split sessions
            this.bindModel({modelPath : 'participants.myEngagements.' + this.visitorId + ".chats", callback: this.updateChatId}); //for split sessions
        }
    });


    ConsumerInfoWidget.prototype.handleWidgetClose = function (data) {
        this.unbindModel({modelPath: 'participants.myEngagements.' + this.visitorId + ".chats", callback: this.updateChatId}); //for split sessions
        this.unbindToModel();
        this.chatId = null;
        this.visitorId = null;
    };

    /**
     * load visitor info either from model or given data
     * @param {object} data
     */
    ConsumerInfoWidget.prototype.loadVisitorInfo = function (data) {
        if (this.chatId) {
            this.visitorInfo = this.getModelParam(this.configuration.chatsRootModelPath + '.' + this.chatId + '.visitorInfo');
            if (!this.visitorInfo && this.configuration.visitorInfoPath) {
                this.visitorInfo = lpUtils.getPropertyValueByPath(data.newValue.eventData, this.configuration.visitorInfoPath);
            }
            this.visitorId = this.visitorInfo.visitorId;
        }
    };

    ConsumerInfoWidget.prototype.unbindToModel = function () {
        if (this.chatId) {
            this.unbindModel({modelPath : this.configuration.chatsRootModelPath + '.' + this.chatId + '.chatInfo', callback: this.handleVisitInfoChanged});
            this.unbindModel({modelPath: this.configuration.chatsRootModelPath + '.' + this.chatId + '.chatInfo.skillIds', callback: this.handleVisitInfoChanged});

        }
        if (this.visitorId) {
            // These are bound in the VisitInfoBase
            this.unbindModel({modelPath : this.getRootModelPath(), callback: this.handleVisitInfoChanged});
            this.unbindModel({modelPath : this.configuration.engagementInfoModelPath + "." + this.visitorId + ".participantTag", callback : this.participantTagChanged});
        }
    };

    ConsumerInfoWidget.prototype.bindToModel = function () {
        VisitInfoBase.prototype.bindToModel.call(this);
        if (this.chatId) {
            this.bindModel({modelPath: this.configuration.chatsRootModelPath + '.' + this.chatId + '.chatInfo', callback: this.handleVisitInfoChanged});
            this.bindModel({modelPath: this.configuration.chatsRootModelPath + '.' + this.chatId + '.chatInfo.skillIds', callback: this.handleVisitInfoChanged});
        }
    };

    ConsumerInfoWidget.prototype.preprocessingHandleVisit = function (data) {
        var visitorData = VisitInfoBase.prototype.preprocessingHandleVisit.call(this, data) || {}; //parent
        if (visitorData.startTime) { // format the start time
            visitorData.startTime = lpUtils.formatDateAsString(visitorData.startTime);
        }
        return visitorData;
    };

    ConsumerInfoWidget.prototype.getConfiguration = function () {
        var configuration = {
            rootModelPath: 'participants.info',
            useDataInPath: true,
            chatsRootModelPath: 'chats',
            search: false
        };
        return configuration;
    };

    ConsumerInfoWidget.prototype.onSelectedVisitorChanged = function (data) {
        if (!data.newValue || !data.newValue.eventData) {
            return;
        }

        if (this.visitorId) {
            this.stopPollingVisitorInfo();
        }

        this.unbindToModel();
        this.getVisitorIdFromData(data);
        this.getChatIdFromData(data);
        this.loadVisitorInfo(data);
        this.bindToModel();
        BaseCategoriesWidget.prototype.onSelectedVisitorChanged.call(this, this.visitorId);
        this.startPollingVisitorInfo();
    };

    ConsumerInfoWidget.prototype.updateChatId = function (data) {
        var chatId = data.newValue ? this.getFirstProperty(data.newValue) : data;
        if (chatId !== this.chatId) {
            this.unbindToModel();
            this.chatId = chatId;
            this.bindToModel();
            this.loadVisitorInfo(data);
        }
    };

    ConsumerInfoWidget.prototype.handleWidgetsClosed = function () {
        this.stopPollingVisitorInfo();
        BaseCategoriesWidget.prototype.unbindEvents.call(this);
    };

    ConsumerInfoWidget.prototype.widgetDataConfig = function () {
        return widgetConfig.getInstance().getWidgetConfig("consumerInfo");
    };

    ConsumerInfoWidget.prototype.getVisitorIdFromData = function (data) {
        if (data && data.newValue && data.newValue.eventData) {
            if (data.newValue.eventData.consumerProfile && data.newValue.eventData.consumerProfile.userId) {
                this.visitorId = data.newValue.eventData.consumerProfile.userId;
            } else if (data.newValue.eventData.visitorInfo && data.newValue.eventData.visitorInfo.visitorId) {
                this.visitorId = data.newValue.eventData.visitorInfo.visitorId;
            }
        }
    };
    ConsumerInfoWidget.prototype.startPollingVisitorInfo = function () {
        lpTag.WebAgent.visitorInfoController.startPollingVisitorInfo(this.visitorId, null, null, this.chatId);
    };

    ConsumerInfoWidget.prototype.stopPollingVisitorInfo = function () {
        lpTag.WebAgent.visitorInfoController.stopPollingVisitorInfo(this.visitorId);
    };

    ConsumerInfoWidget.prototype.getChatIdFromData = function (data) {
        if (data && data.newValue && data.newValue.eventData) {
            if (data.newValue.eventData.convId) {
                this.chatId = data.newValue.eventData.convId;
            } else if (this.configuration.chatIdPath) {
                this.chatId = lpUtils.getPropertyValueByPath(data.newValue.eventData, this.configuration.chatIdPath);
            }
        }
    };

    return ConsumerInfoWidget;

});
